
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enroll/document-check",
      function () {
        return require("private-next-pages/enroll/document-check.tsx");
      }
    ]);
  